import { ref } from 'vue'

export type SaveState = 'unsaved' | 'saving' | 'saved' | 'error'

// export function useSaveStatus() {
export function useSaveStatus(saveFn?: () => Promise<void>) {
  const saveStatus = ref<SaveState>('saved')
  let saveTimer: number | null = null

  function markUnsaved() {
    saveStatus.value = 'unsaved'
  }

  async function performSave() {
    if (!saveFn) return
    saveStatus.value = 'saving'
    try {
      // 💡 Simulated delay to look like a save
      // await new Promise((resolve) => setTimeout(resolve, 1000))
      await saveFn()
      saveStatus.value = 'saved'
    } catch {
      saveStatus.value = 'error'
    }
  }

  function triggerAutosave() {
    markUnsaved()
    if (saveTimer) clearTimeout(saveTimer)
    saveTimer = window.setTimeout(performSave, 1500)
  }

  return { saveStatus, triggerAutosave }
}